/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Position } from './Position';
import {
    PositionFromJSON,
    PositionFromJSONTyped,
    PositionToJSON,
} from './Position';

/**
 * 
 * @export
 * @interface SourceDetail
 */
export interface SourceDetail {
    /**
     * 
     * @type {string}
     * @memberof SourceDetail
     */
    callsign?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceDetail
     */
    destination?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceDetail
     */
    draught?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceDetail
     */
    eta?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceDetail
     */
    imo?: number;
    /**
     * 
     * @type {number}
     * @memberof SourceDetail
     */
    mmsi?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceDetail
     */
    name?: string;
    /**
     * 
     * @type {Position}
     * @memberof SourceDetail
     */
    position?: Position;
}

/**
 * Check if a given object implements the SourceDetail interface.
 */
export function instanceOfSourceDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SourceDetailFromJSON(json: any): SourceDetail {
    return SourceDetailFromJSONTyped(json, false);
}

export function SourceDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'callsign': !exists(json, 'callsign') ? undefined : json['callsign'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'draught': !exists(json, 'draught') ? undefined : json['draught'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'position': !exists(json, 'position') ? undefined : PositionFromJSON(json['position']),
    };
}

export function SourceDetailToJSON(value?: SourceDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'callsign': value.callsign,
        'destination': value.destination,
        'draught': value.draught,
        'eta': value.eta,
        'imo': value.imo,
        'mmsi': value.mmsi,
        'name': value.name,
        'position': PositionToJSON(value.position),
    };
}

